class Translator {
    constructor(root = document) {
        this.messages = this._load(root);
    }

    _load(root) {
        const node = root?.getElementById?.('app-translations');
        if (!node) {
            console.warn('Translator: #app-translations not found');
            return {};
        }

        try {
            const parsed = JSON.parse(node.textContent || '{}');
            if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
                console.warn('Translator: translation catalog must be an object');
                return {};
            }
            return parsed;
        } catch (error) {
            console.warn('Translator: invalid translation catalog', error);
            return {};
        }
    }

    has(key) {
        return Object.prototype.hasOwnProperty.call(this.messages, key);
    }

    trans(key, parameters = {}) {
        if (!this.has(key)) {
            console.warn(`Translator: missing translation key "${key}"`);
            return key;
        }

        const value = String(this.messages[key] ?? '');

        return value.replace(/%([A-Za-z0-9_.-]+)%/g, (match, name) => {
            if (!Object.prototype.hasOwnProperty.call(parameters, name)) {
                return match;
            }
            return String(parameters[name] ?? '');
        });
    }
}

export default Translator;
